import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import auth from './modules/auth'
import validation from './modules/validation'
import monthlyDetail from './modules/monthly-detail'

Vue.use(Vuex)

export default new Vuex.Store({

    modules: {
        auth,
        validation,
        monthlyDetail
    },
    
    plugins: [
        createPersistedState({
            paths: ['auth.user']
        })
    ],

})
